import React from 'react';
import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./BalancesPayouts.module.scss";

interface StatusRendererProps extends CustomCellRendererProps {
  value: string;
}

export const StatusRenderer = (props: StatusRendererProps) => {
  const getStatusClass = (status: string) => {
    switch (status) {
      case 'paid':
        return 'complete';
      case 'pending':
        return 'pending';
      case 'in_transit':
        return 'pending';
      case 'canceled':
      case 'failed':
        return 'failed';
      default:
        return 'pending';
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'paid':
        return 'Paid';
      case 'pending':
        return 'Pending';
      case 'in_transit':
        return 'In Transit';
      case 'canceled':
        return 'Canceled';
      case 'failed':
        return 'Failed';
      default:
        return status;
    }
  };

  return (
    <div className={styles.StatusRenderer}>
      <div className={`${styles.status} ${styles[getStatusClass(props.value)]}`}>
        {getStatusLabel(props.value)}
      </div>
    </div>
  );
}; 